import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

// Images & Icons
import RedWarningIcon from 'assets/icons/general/RedWarningIcon.png'

function ModalConfirmation({
    open,
    setOpen,
    title,
    description,
    notifyButton,
    confirmButton,
    cancelButton,
}) {

    return (
        <Dialog open={open} onClose={setOpen} className="relative z-50 ">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg md:max-w-2xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                                <div className="mx-auto flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-8 sm:w-8">
                                    <img
                                        className="w-full"
                                        src={RedWarningIcon}
                                        alt="waring-mark-icon"
                                    />
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base md:text-lg lg:text-2xl font-semibold leading-6 text-gray-900">
                                        {title}
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm md:text-base lg:text-lg text-gray-500">
                                            {description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-gray-50 space-y-2 sm:space-y-0 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            {notifyButton && (
                                <button
                                    type="button"
                                    onClick={setOpen}
                                    className="inline-flex w-full justify-center rounded-md bg-black px-3 py-2 text-sm md:text-base font-bold text-white shadow-sm hover:bg-gray-600 sm:ml-3 sm:w-auto"
                                >
                                    OK
                                </button>
                            )}
                            {confirmButton && (
                                <button
                                    type="button"
                                    onClick={() => setOpen(true)}
                                    className="inline-flex w-full justify-center rounded-md bg-black px-3 py-2 text-sm md:text-base font-bold text-white shadow-sm hover:bg-gray-600 sm:ml-3 sm:w-auto"
                                >
                                    Yes
                                </button>
                            )}
                            {cancelButton && (
                                <button
                                    type="button"
                                    onClick={() => setOpen(false)}
                                    className="inline-flex w-full justify-center rounded-md bg-gray-400 px-3 py-2 text-sm md:text-base text-white shadow-sm hover:bg-gray-300 sm:ml-3 sm:w-auto"
                                >
                                    Cancel
                                </button>
                            )}
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}

export default ModalConfirmation
